import Api from '@/services/Api'

export default {
  getPostcodes (token) {
    return Api().get('postcodes')
  },

  addPostcode (params) {
    return Api().post('postcodes', params)
  },

  deletePostcode (id) {
    return Api().delete('postcode/' + id)
  },

  getSinglePostcode (postcode) {
    return Api().get('postcodeByPostcode/' + postcode)
  }
}



// WEBPACK FOOTER //
// ./src/services/PostcodeService.js